


export default class LanguagesDropdown {

    constructor(){

        var $has_another_languages = jQuery( '.languages-dropdown__selector--has-multiple-languages' ) ;

        if( $has_another_languages.length > 0 ){

            jQuery('.languages-dropdown__current').on('click', function (e) {

                console.log('click');

                e.preventDefault();
                jQuery(this).parent().toggleClass('is-active');
            });
        }

    }


}


